module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('reward.remove')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("reward.deleteInfo")))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeReward(_vm.reward)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("remove")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4e2302"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reward/Remove.vue
// module id = 789
// module chunks = 1